import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';
import { MainLayout } from './components/layout/MainLayout';
import { MarketsPage } from './components/markets/MarketsPage';
import { MarketSearchPage } from './components/search/MarketSearchPage';
import { SignInPage } from './components/auth/SignInPage';
import { SignUpPage } from './components/auth/SignUpPage';
import { ForgotPasswordPage } from './components/auth/ForgotPasswordPage';
import { ResetPasswordPage } from './components/auth/ResetPasswordPage';
import { AdminLayout } from './components/admin/AdminLayout';
import { SharedAnalysis } from './components/analysis/SharedAnalysis';
import { LikedSearchesPage } from './components/user/LikedSearchesPage';
import { LikedSearchPage } from './components/user/LikedSearchPage';
import { PreviousSearchesPage } from './components/user/PreviousSearchesPage';
import { HistorySearchPage } from './components/user/HistorySearchPage';
import { PrivacyPolicy } from './components/legal/PrivacyPolicy';
import { TermsAndConditions } from './components/legal/TermsAndConditions';
import { BillingPage } from './components/billing/BillingPage';
import { PaymentSuccessPage } from './components/billing/PaymentSuccessPage';
import { PaymentCancel } from './components/billing/PaymentCancel';
import { PaymentDirectPage } from './components/billing/PaymentDirectPage';
import { CryptoForm } from './components/billing/CryptoForm';
import { WhyBangaPage } from './components/pages/WhyBangaPage';
import { useReferralTracking } from './hooks/useReferralTracking';

export const AppRoutes: React.FC = () => {
  // Track referral on initial load
  useReferralTracking();

  return (
    <div className="min-h-screen flex flex-col bg-gray-100 dark:bg-gray-900">
      <Header />
      <main className="flex-1 flex items-center justify-center py-12 px-4">
        <div className="w-full max-w-7xl mx-auto">
          <Routes>
            {/* Auth routes */}
            <Route path="/signin" element={<SignInPage />} />
            <Route path="/signup" element={<SignUpPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            
            {/* Admin routes */}
            <Route path="/admin/*" element={<AdminLayout />} />
            
            {/* Market routes */}
            <Route path="/markets" element={<MarketsPage />} />
            <Route path="/markets/:marketId" element={<MarketSearchPage />} />
            
            {/* Analysis routes */}
            <Route path="/shared/:shareId" element={<SharedAnalysis />} />
            
            {/* User routes */}
            <Route path="/liked-searches" element={<LikedSearchesPage />} />
            <Route path="/liked-searches/search" element={<LikedSearchPage />} />
            <Route path="/search-history" element={<PreviousSearchesPage />} />
            <Route path="/search-history/search" element={<HistorySearchPage />} />
            
            {/* Billing route */}
            <Route path="/billing" element={<BillingPage />} />
            <Route path="/billing/cryptoform" element={<CryptoForm />} /> 
            
            {/* Payment routes */}
            <Route path="/payment/success" element={<PaymentSuccessPage />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/payment/direct" element={<PaymentDirectPage />} />
            
            {/* Legal routes */}
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsAndConditions />} />
            <Route path="/why-banga" element={<WhyBangaPage />} />
            
            {/* Referral route */}
            <Route path="/r/:code" element={<MainLayout />} />
            
            {/* Home route */}
            <Route path="/" element={<MainLayout />} />
            
            {/* Catch-all route - Only redirects unknown routes */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </main>
      <Footer />
    </div>
  );
};